import { SafeCollector3ss0wp8n80f6m as SafeCollector } from './internal/SafeCollector.mjs';
import { $3l5vvh8yg0ier as $ } from '../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/coroutinesInteropJs.mjs';
import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { FlowCollector26clgpmzihvke as FlowCollector } from './FlowCollector.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { fuseSharedFlow3r8bpddms9npl as fuseSharedFlow } from './SharedFlow.mjs';
import {
  fuse$default2v3gehkaa3idr as fuse$default,
  FusibleFlow2tgh9s2p1kryd as FusibleFlow,
} from './internal/ChannelFlow.mjs';
import { protoOf180f3jzyo7rfj as protoOf } from '../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { throwKotlinNothingValueException2lxmvl03dor6f as throwKotlinNothingValueException } from '../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function asSharedFlow(_this__u8e3s4) {
  return new (ReadonlySharedFlow())(_this__u8e3s4, null);
}
function onSubscription(_this__u8e3s4, action) {
  return new (SubscribedSharedFlow())(_this__u8e3s4, action);
}
var SubscribedFlowCollectorClass;
function SubscribedFlowCollector() {
  if (SubscribedFlowCollectorClass === VOID) {
    class $_0 {
      constructor(collector, action) {
        this.collector_1 = collector;
        this.action_1 = action;
      }
      *onSubscription_q7qr5n_k$($completion) {
        // Inline function 'kotlinx.coroutines.currentCoroutineContext' call
        // Inline function 'kotlin.js.getCoroutineContext' call
        var tmp$ret$0 = $completion.get_context_h02k06_k$();
        var safeCollector = new (SafeCollector())(this.collector_1, tmp$ret$0);
        try {
          yield* $(this.action_1(safeCollector, $completion), $completion);
        }finally {
          safeCollector.releaseIntercepted_5cyqh6_k$();
        }
        var tmp = this.collector_1;
        if (tmp instanceof SubscribedFlowCollector())
          yield* this.collector_1.onSubscription_q7qr5n_k$($completion);
        return Unit_instance;
      }
      *emit_t92u1f_k$(value, $completion) {
        yield* this.collector_1.emit_t92u1f_k$(value, $completion);
        return Unit_instance;
      }
    }
    initMetadataForClass($_0, 'SubscribedFlowCollector', VOID, VOID, [FlowCollector()], [0, 1]);
    SubscribedFlowCollectorClass = $_0;
  }
  return SubscribedFlowCollectorClass;
}
var ReadonlySharedFlowClass;
function ReadonlySharedFlow() {
  if (ReadonlySharedFlowClass === VOID) {
    class $ {
      constructor(flow, job) {
        this.$$delegate_0__1 = flow;
        this.job_1 = job;
      }
      fuse_x525ca_k$(context, capacity, onBufferOverflow) {
        return fuseSharedFlow(this, context, capacity, onBufferOverflow);
      }
      *collect_ve9kyv_k$(collector, $completion) {
        yield* this.$$delegate_0__1.collect_ve9kyv_k$(collector, $completion);
        throwKotlinNothingValueException();
      }
      collect_aksokr_k$(collector, $completion) {
        return this.collect_ve9kyv_k$(collector, $completion);
      }
    }
    protoOf($).fuse$default_g5zl2z_k$ = fuse$default;
    initMetadataForClass($, 'ReadonlySharedFlow', VOID, VOID, [FusibleFlow()], [1]);
    ReadonlySharedFlowClass = $;
  }
  return ReadonlySharedFlowClass;
}
var SubscribedSharedFlowClass;
function SubscribedSharedFlow() {
  if (SubscribedSharedFlowClass === VOID) {
    class $ {
      constructor(sharedFlow, action) {
        this.sharedFlow_1 = sharedFlow;
        this.action_1 = action;
      }
      *collect_ve9kyv_k$(collector, $completion) {
        yield* this.sharedFlow_1.collect_ve9kyv_k$(new (SubscribedFlowCollector())(collector, this.action_1), $completion);
        return throwKotlinNothingValueException();
      }
      collect_aksokr_k$(collector, $completion) {
        return this.collect_ve9kyv_k$(collector, $completion);
      }
    }
    initMetadataForClass($, 'SubscribedSharedFlow', VOID, VOID, VOID, [1]);
    SubscribedSharedFlowClass = $;
  }
  return SubscribedSharedFlowClass;
}
//region block: exports
export {
  SubscribedFlowCollector as SubscribedFlowCollector17ch8by19noql,
  asSharedFlow as asSharedFlow2buz3fbrowsyg,
  onSubscription as onSubscription3iwvbdmbwg7iq,
};
//endregion

//# sourceMappingURL=Share.mjs.map
